const addInfo = {
  title: 'Safety',
  icon: 'safety'
}
const safetyRouter = {
  path: '/safety',
  meta: {
    title: 'Safety',
    icon: 'safety', //remember add addInfo for favourite function
    permission: ['safety']
  },
  children: [
    // {
    //   path: 'safety-monitoring',
    //   component: () => import('@/views/safety/monitoring/safety-monitoring'),
    //   name: 'SafetyMonitoring',
    //   meta: { title: 'SafetyMonitoring', parent: addInfo }
    // },
    // {
    //   path: 'ai-safety-monitoring',
    //   component: () => import('@/views/safety/monitoring/ai-safety-monitoring'),
    //   name: 'AiSafetyMonitoring',
    //   meta: { title: 'AiSafetyMonitoring', parent: addInfo }
    // },
    {
      path: 'safety',
      component: () => import('@/views/safety/overview/safety'),
      name: 'SafetyDashboard',
      meta: { title: 'SafetyDashboard', parent: addInfo, permission: ['safety_dashboard_enable']}
    },
    {
      path: 'advance-safety',
      component: () => import('@/views/safety/overview/advance-safety'),
      name: 'AdvanceSafety',
      meta: { title: 'AdvanceSafety', parent: addInfo, permission: ['safety_dashboard_enable'] }
    },
    /*{
      path: 'driver-performance',
      component: () => import('@/views/safety/driverPerformance/driver-performance'),
      name: 'DriverPerformance',
      meta: { title: 'DriverPerformance', parent: addInfo }
    },*/
    {
      path: 'driver-performance',
      component: () => import('@/views/safety/driverPerformance/driver-performance'),
      name: 'DriverPerformance',
      meta: { title: 'DriverPerformance', parent: addInfo, permission: ['safety_driver_performance_enable'] }
    },
    {
      path: 'driver-performance-details/:id?',
      component: () => import('@/views/safety/driverPerformance/component/driver-performance-details'),
      name: 'DriverPerformanceDetails',
      hidden: true,
      meta: { title: 'DriverPerformanceDetails', activeMenu: '/safety/driver-performance', enableBack: true, backPage: 'DriverPerformance', permission: ['safety_driver_performance_enable'] }
    },
    {
      path: 'vehicle-performance',
      component: () => import('@/views/safety/vehiclePeformance/vehicle-performance'),
      name: 'VehiclePerformance',
      meta: { title: 'VehiclePerformance', parent: addInfo, permission: ['safety_vehicle_performance_enable'] }
    },
    {
      path: 'vehicle-performance-details/:id?',
      component: () => import('@/views/safety/vehiclePeformance/component/vehicle-performance-details'),
      name: 'VehiclePerformanceDetails',
      hidden: true,
      meta: { title: 'VehiclePerformanceDetails', activeMenu: '/safety/vehicle-performance', enableBack: true, backPage: 'VehiclePerformance', permission: ['safety_vehicle_performance_enable'] }
    },
    {
      path: 'event-details',
      component: () => import('@/views/safety/safetyEvent/safety-event'),
      name: 'SafetyEvent',
      meta: { title: 'SafetyEvent', parent: addInfo, permission: ['safety_event_enable'] }
    },
    // {
    //   path: 'event-details-drawer/:id?',
    //   component: () => import('@/views/safety/safetyEvent/component/event-details-drawer'),
    //   name: 'EventDetailsDrawer',
    //   hidden: true,
    //   meta: { title: 'EventDetailsDrawer', activeMenu: '/event-details', enableBack: true, backPage: 'EventDetails' }
    // },
    {
      path: 'speeding',
      component: () => import('@/views/safety/speedingBehavior/speeding'),
      name: 'Speeding',
      meta: { title: 'Speeding', parent: addInfo, permission: ['safety_speeding_enable'] }
    },
  ]
}

export default safetyRouter
